/*添加服务*/
define('services/mysetting/mod.userinfo.service',['app', 'mainCons'], function (app, mainCons) {
    return app.factory('modUserInfoService', ['$q', '$state', '$filter', 'ngDialog', 'auiDialog', 'OpenUp', 'OpenOther', 'UserInfo',
        function ($q, $state, $filter, ngDialog, auiDialog, OpenUp, OpenOther, UserInfo) {


            function getPerValid() {
                return {
                    realNameValid: {
                        isValidSuc: true,
                        isShowValid: false,
                        validMsg: '真实姓名格式不对'
                    },
                    emailValid: {
                        isValidSuc: true,
                        isShowValid: false,
                        validMsg: '邮箱格式不对'
                    },
                    phoneValid: {
                        isValidSuc: true,
                        isShowValid: true,
                        validMsg: ''
                    },
                    idCardValid: {
                        isValidSuc: true,
                        isShowValid: false,
                        validMsg: '身份证号码格式不对',
                        isRepeat: false
                    },
                    ctf3Valid: {
                        isValidSuc: true,
                        validMsg: '请上传手持证件照'
                    },
                    perCtfFgValid: {
                        isValidSuc: true,
                        validMsg: '请上传身份证正面'
                    },
                    perCtfBgValid: {
                        isValidSuc: true,
                        validMsg: '请上传身份证反面'
                    },
                    qqValid: {
                        isValidSuc: true,
                        isShowValid: false,
                        validMsg: 'QQ号码格式不对'
                    }

                }
            }

            function getExtAttr(name) {
                var defer = $q.defer();
                OpenUp.getExtAttr({
                    req: {name: name}
                }).then(function (res) {
                    if (existPara(res.value) && 1 == res.value) {
                        defer.resolve(1);
                    } else if (res.value == null) {
                        defer.resolve('null');
                    } else {
                        defer.resolve(0);
                    }
                }).catch(function () {
                    defer.resolve(0);
                });
                return defer.promise;
            }


            function existPara(value) {
                if (value != undefined && value != null) {
                    return true;
                } else {
                    return false;
                }
            }

            //修改用户信息
            function updateUserInfo(params) {
                var defer = $q.defer();
                if (params.indivDeveloper && params.indivDeveloper.ctfCode) {
                    params.indivDeveloper.ctfCode = angular.copy(params.indivDeveloper.ctfCode.replace(/x/, "X"))
                }
                UserInfo.updateUser(params).then(function (res) {
                    defer.resolve(res);
                }).catch(function (res) {
                    defer.resolve(res);
                });
                return defer.promise;
            }

            //修改银行信息
            function updateBankInfo(params, callback) {
                UserInfo.updateBank(params).then(function (res) {
                    callback(res);
                }).catch(function (res) {
                    callback(res);
                });
            }


            //查询SrmPrm报错信息
            function getNotifyMessage(callback) {
                OpenUp.getNotifyMessage({
                    "req": {displayPosition: 1}
                }).then(function (res) {
                    if (res && res.resultCode === 0) {
                        callback(res.message);
                    }
                });
            }

            //提交更名信息
            function changeNameFun(params) {
                var defer = $q.defer();
                if (params.indivDeveloper && params.indivDeveloper.perCtfCode) {
                    params.indivDeveloper.perCtfCode = angular.copy(params.indivDeveloper.perCtfCode.replace(/x/, "X"));
                }
                if (params.developerMerchantInfo && params.developerMerchantInfo.taxAttrs) {
                    delete params.developerMerchantInfo.taxAttrs.taxType;
                    delete params.developerMerchantInfo.taxAttrs.taxProvince;
                    delete params.developerMerchantInfo.taxAttrs.taxCity;
                }
                delete params.notShowTip;
                if (params.developerMerchantInfo && params.developerMerchantInfo.taxAttrs) {
                    params.developerMerchantInfo.taxAttrs = JSON.stringify(params.developerMerchantInfo.taxAttrs);
                }
                if (params.developerMerchantInfo && params.developerMerchantInfo.contactList) {
                    params.developerMerchantInfo.contactList = JSON.stringify(params.developerMerchantInfo.contactList);
                }
                if (params.developerInfo && params.developerInfo.contactPhone) {
                    params.developerInfo.contactPhone = "0086" + params.developerInfo.contactPhone.replace("+", "00");
                }
                delete params.isRepeatCorpName;
                UserInfo.changeNameFun(params).then(function (data) {
                    if (data && data.userID) {
                        defer.resolve(data);
                    } else {
                        if (data && data.NSP_STATUS && data.NSP_STATUS === 70005010 && data.error) {
                            var error = data.error;
                            var re = /\[[^\]]*\]/g;
                            var branchNumber = re.exec(error);
                            var branchName = re.exec(error);
                            var selBranchName = re.exec(error);
                            var msg = "开户行号为" + branchNumber + "对应的支行名称为" + branchName + "，与输入的" + selBranchName + "不匹配，请在商户服务信息设置页面重新输入或选择。";
                            defer.reject();
                            auiDialog.fail(msg);
                        }
                        defer.reject();
                        auiDialog.failSystemError($filter('auiErrorCode')(data.NSP_STATUS, data.serviceName));
                    }
                }).catch(function (data) {
                    if (data && data.NSP_STATUS && data.NSP_STATUS === 70005010 && data.error) {
                        var error = data.error;
                        var re = /\[[^\]]*\]/g;
                        var branchNumber = re.exec(error);
                        var branchName = re.exec(error);
                        var selBranchName = re.exec(error);
                        var msg = "开户行号为" + branchNumber + "对应的支行名称为" + branchName + "，与输入的" + selBranchName + "不匹配，请重新输入或选择。";
                        defer.reject();
                        auiDialog.fail(msg);
                    }

                    defer.reject();
                    auiDialog.failSystemError($filter('auiErrorCode')(data.NSP_STATUS, data.serviceName));
                });
                return defer.promise;
            }

            function saveOldUserInfo(oU, user) {
                for (var i in user) {
                    oU[i] = user[i];
                }
                // 把accepEDM转义为 boolean （1：true, 其他:false)
                if (user.acceptEDM) {
                    user.acceptEDM = user.acceptEDM == 1 ? true : false;
                    oU.acceptEDM = oU.acceptEDM == 1 ? true : false;
                }
            }

            function selectChannelType(value, Model, primes, differValue, sameValue, oldUserInfo) {
                if (Model.isAudting) return;
                if (Model.channelsChecked) {
                    if (AUI.BaseJSUtil.contains(Model.channelsChecked, value)) {
                        AUI.BaseJSUtil.arrayRemove(Model.channelsChecked, value);
                    } else {
                        Model.channelsChecked.push(value)
                    }
                    if (AUI.BaseJSUtil.contains(Model.channelsChecked, 0)) {
                        AUI.BaseJSUtil.arrayRemove(Model.channelsChecked, 0);
                        Model.channelsChecked.push(0);
                    }
                    var prime = primes.learnchannels;
                    // 如果新值跟原值不一样，则亮化提交按钮，并计入changeNum
                    if (oldUserInfo.learnchannels) {
                        if (oldUserInfo.learnchannels.split(";").sort().toString() != Model.channelsChecked.sort().toString()) {
                            differValue && differValue(prime);
                        } else {
                            sameValue && sameValue(prime);
                        }
                    } else {
                        if (Model.channelsChecked.length > 0) {
                            differValue && differValue(prime);
                        } else {
                            sameValue && sameValue(prime);
                        }
                    }
                    Model.channelOtherCheck = Model.channelsChecked.length == 0;
                }
            }

            function drawImage(Model, key, keywh, $scope) {
                AUI.HTMLUtil.drawImage(180, 120, Model.userInfo[key], function (wh) {
                    $scope.$apply(function () {
                        Model[keywh] = wh;
                    });
                });
            }

            function returnPrimes() {
                return {
                    contactorImg1Prime: 2,
                    contactorImg2Prime: 3,
                    contactorImg3Prime: 5,
                    corpNameChangePrime: 7,
                    contactorImg11Prime: 11,
                    contactorImg10Prime: 13,
                    corpLicensePrime: 17,
                    taxPrime: 19,
                    corpCodePrime: 23,
                    corpEntityPicFilePrime: 29,
                    corpEntityPicFile1Prime: 31,
                    corpNamePrime: 37,
                    realNameEnPrime: 41,
                    provincePrime: 43,
                    cityPrime: 47,
                    addressPrime: 53,
                    contactNamePrime: 59,
                    contactEmailPrime: 61,
                    contactPhonePrime: 67,
                    qqPrime: 71,
                    learnchannels: 73,
                    learnchannelsOther: 79,
                    remark4userinfo: 83,
                    acceptEDM: 89,
                    corpBsLicIDPrime: 97,
                    devName4InnerPrime: 101,
                    msgLangPrime: 103,
                    devNameEn4InnerPrime: 107,
                    appealAttach: 109,
                    realNamePrime: 127,
                    idNumberPrime: 131,
                    idCardPicFgPrime: 137,
                    idCardPicBgPrime: 139,
                    idCarePic3Prime: 149,
                    perCtfNcPrime: 151,
                    bankProvincePrime: 157,
                    bankCityPrime: 163,
                    branchPrime: 167,
                    accountNamePrime: 173,
                    bankAccountPrime: 179,
                    legalManPrime:181,
                    legalManCtfCodePrime:191,
                    contactIdCardPrime:193

                    //151 157 163 167 173    179 181 191 193 197 199 还有这些可用
                }
            }

            function handleSelectChannel(Model, value) {
                if (Model.channelsChecked) {
                    if (AUI.BaseJSUtil.contains(Model.channelsChecked, value)) {
                        AUI.BaseJSUtil.arrayRemove(Model.channelsChecked, value);
                    } else {
                        Model.channelsChecked.push(value);
                    }
                    if (AUI.BaseJSUtil.contains(Model.channelsChecked, 0)) {
                        AUI.BaseJSUtil.arrayRemove(Model.channelsChecked, 0);
                        Model.channelsChecked.push(0);
                    }
                    Model.channelOtherCheck = (Model.channelsChecked.length == 0);
                }
            }

            // 输入控件值与原值一样，处理changeNum及提交按钮的样式
            function sameValue(prime, changeNum) {
                // 跟原值一样，从changeNum清除本项计数
                if (changeNum % prime == 0) {
                    // 计数中存在本项，则需要清除
                    changeNum = changeNum / prime;
                }
                return changeNum;
            }

            // 输入控件值与原值不一样，处理changeNum及提交按钮的样式
            function differValue(prime, changeNum) {
                if (changeNum % prime != 0) {
                    // 计数中没有本项，则需要加上
                    changeNum = changeNum * prime;
                }
                return changeNum;
            }

            function setLearnchannels(oldUserInfo, Model, devObj) {
                if (oldUserInfo.learnchannels) {
                    if (oldUserInfo.learnchannels.split(";").sort().toString() != Model.channelsChecked.sort().toString) {
                        if (AUI.BaseJSUtil.contains(Model.channelsChecked, 0)) {
                            AUI.BaseJSUtil.arrayRemove(Model.channelsChecked, 0);
                            Model.channelsChecked.push(0);
                        }
                        devObj.learnchannels = Model.channelsChecked.length > 0 ? Model.channelsChecked.join(";") : '';
                        if (AUI.BaseJSUtil.contains(Model.channelsChecked, 0) && oldUserInfo.learnchannelsOther != Model.userInfo.learnchannelsOther) {
                            devObj.learnchannelsOther = $.trim(Model.userInfo.learnchannelsOther);
                        }
                    }
                } else {
                    devObj.learnchannels = Model.channelsChecked.length > 0 ? Model.channelsChecked.join(";") : '';
                    if (AUI.BaseJSUtil.contains(Model.channelsChecked, 0) && oldUserInfo.learnchannelsOther != Model.userInfo.learnchannelsOther) {
                        devObj.learnchannelsOther = $.trim(Model.userInfo.learnchannelsOther);
                    }
                }
            }

            function returnValidOptions() {
                return {
                    corpNameValid: {
                        isRepeat: false
                    },
                    corpBsLicIDValid: {
                        isRepeat: false
                    },
                    emailValid: {
                        isValidSuc: true,
                        isShowValid: false,
                        validMsg: ''
                    },
                    phoneValid: {
                        isValidSuc: true,
                        isShowValid: true,
                        validMsg: ''
                    }
                }
            }

            function validateDataEmailAndPhone(Model) {
                var flag = true;
                // 校验手机号码
                if (Model.userInfo.contactPhone && (!AUI.BaseJSUtil.lengthCheck(Model.userInfo.contactPhone, 64, 1)) || (!AUI.BaseJSUtil.isMobile(Model.userInfo.contactPhone))) {
                    flag = false;
                    // 显示错误提示
                    Model.valid.phoneValid = {
                        isValidSuc: false,
                        isShowValid: true,
                        validMsg: mainCons.modUserinfoConstant.validMsg.validPhone.formatError
                    };
                    Model.isShowphoneValid = false;
                } else {
                    // 隐藏错误提示
                    Model.valid.phoneValid = {
                        isValidSuc: true,
                        isShowValid: false
                    };
                }
                if (Model.valid.emailValid.isShowValid || (!UserInfo.checkIsSameWithUPEmail(Model.userInfo.contactEmail, Model.userInfo.accountEmail) && !Model.verifiedEmailSuccess)) {
                    angular.element("[name='verifyEmailCode']").focus();
                    return false;
                }
                if (Model.valid.phoneValid.isShowValid || (!UserInfo.checkIsSameWithUPPhone(Model.userInfo.contactPhone, Model.userInfo.accountPhone) && !Model.verifiedPhoneSuccess)) {
                    flag = false;
                    angular.element("[name='verifyCode']").focus();
                }
                return flag;

            }

            function validatePhone() {
                return {
                    test: function (value) {
                        if (value) {
                            return AUI.BaseJSUtil.isMobile(value);
                        } else {
                            return true;
                        }
                    }
                };
            }


            // 根据企业名称或者个人身份证返回是否重复
            function checkUser(setting) {
                var defer = $q.defer();
                OpenUp.checkUser({
                    req: {
                        userType: setting.userType,
                        ctfCode: setting.ctfCode ? setting.ctfCode : '',
                        corpBsLicID: setting.corpBsLicID ? setting.corpBsLicID : '',
                        corpName: setting.corpName ? setting.corpName : ''
                    }
                }).then(function (res) {
                    defer.resolve(res);
                }).catch(function (res) {
                    defer.reject(res);
                });
                return defer.promise;
            }

            function isSupportDevName() {
                var defer = $q.defer();
                OpenUp.isAllowDevName({req: {}}).then(function (data) {
                    if (data && data.isAllow && data.isAllow == '1') {
                        defer.resolve(true);
                    } else {
                        defer.resolve(false);
                    }
                }).catch(function () {
                    defer.resolve(false);
                });
                return defer.promise;
            }




            return {
                'updateUserInfo': updateUserInfo,
                'changeNameFun': changeNameFun,
                'updateBankInfo': updateBankInfo,
                'getNotifyMessage': getNotifyMessage,
                'getExtAttr': getExtAttr,
                'saveOldUserInfo': saveOldUserInfo,
                'selectChannelType': selectChannelType,
                "drawImage": drawImage,
                "returnPrimes": returnPrimes,
                "handleSelectChannel": handleSelectChannel,
                "sameValue": sameValue,
                "differValue": differValue,
                "setLearnchannels": setLearnchannels,
                "returnValidOptions": returnValidOptions,
                validateDataEmailAndPhone: validateDataEmailAndPhone,
                validatePhone: validatePhone,
                'getPerValid': getPerValid,
                'checkUser': checkUser,
                'isSupportDevName': isSupportDevName

            }
        }]);
});

